<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="error")
  .custom-fields-overview
    CustomFieldsTable(v-if="customFields" :custom-fields="customFields")
    p(v-else) There are currently no custom fields
</template>

<script>
import CustomFieldsTable from '@/vue/settings/application/custom-fields/CustomFieldsTable.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomFieldsOverview',
  components: { CustomFieldsTable },
  data() {
    return {
      isFetching: true,
      error: null,
    }
  },
  computed: mapState('customFields', ['customFields']),
  methods: mapActions('customFields', ['maybeFetchCustomFields']),
  async mounted() {
    this.isFetching = true
    try {
      await this.maybeFetchCustomFields()
    } catch (e) {
      this.$notifyError('Unable to fetch custom fields')
      this.error = e
    }
    this.isFetching = false
  },
}
</script>

<style lang="stylus">
.custom-fields-overview
  padding 4em
  width 66.7%
  margin 0 auto
  min-width 800px
</style>
